type Props = {
  width?: string;
  height?: string;
  fillColor?: string;
};

export default function DashedRectIcon({
  width = '14',
  height = '14',
  fillColor = 'white',
}: Props) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.975 10.85H3.46719V11.6375H2.1875V10.3578H2.975V10.85ZM8.38906 10.85V11.6375H5.43594V10.85H8.38906ZM10.85 10.3578H11.6375V11.6375H10.3578V10.85H10.85V10.3578ZM11.6375 5.43594V8.38906H10.85V5.43594H11.6375ZM2.975 5.43594V8.38906H2.1875V5.43594H2.975ZM10.85 2.975H10.3578V2.1875H11.6375V3.46719H10.85V2.975ZM2.975 2.975V3.46719H2.1875V2.1875H3.46719V2.975H2.975ZM8.38906 2.1875V2.975H5.43594V2.1875H8.38906Z"
        fill={fillColor}
      />
    </svg>
  );
}
